export default theme => ({
  root: {
    paddingLeft: 20
  },
  icon: {
    minWidth: 48
  },
  text: {
    fontSize: 12,
    lineHeight: 'normal',
    color: ({ active, selected }) =>
      (active && theme.palette.primary.main) || (selected && 'black') || theme.palette.neutral.darkBlue,
    opacity: ({ active, selected }) => (active || selected ? 0.7 : 0.5),
    fontWeight: ({ selected }) => (selected ? 500 : 400)
  }
});
